<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_2"></a>For Clay Walsh.<br/>You are my sun, my moon, and my stars.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03-dedication.vue?44e88fa6